import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/auth';
import { AutoCompleteBox, DateBox, FormButton } from "../commoncomponents/InputBox";
//loder
import BlurLoader from "../Loder/BlurLoader";

//react toast 
import { toast } from 'react-toastify';

//common Data
import { API_SERVER, initializeFilterData } from '../../Utils';

//services
import { getCommonData } from '../../apiservices/CommonServices';
import { post } from '../../apiservices/service';
import { Token } from '../Common/Common';
import { OperationalTable } from '../commoncomponents/OperationalTable';


function AttandanceVerification() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();

    const TokenData = Token()
    //initial state
    const [recipe, setRecipe] = useState({
        //  CandidateID: '0',
        Company: user.company,
        Employee: '',
        FromDate: '',
        ToDate: ''


    })
    const navigate = useNavigate()
    const [EmployeeData, setEmployeeData] = useState([])
    const [CompanyData, setCompanyData] = useState([])
    const [AttendanceDetails, setAttendanceDetails] = useState([])
    const [showTable, setShowTable] = useState(false)
    const [errors, setErrors] = useState({});
    const [result, setResult] = useState({});
    const [loading, setLoading] = useState(false)
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData)

    const [isUpdate, setIsUpdate] = useState(false)
    const [dateOfBirth, setDateOfBirth] = useState(new Date());
    // const [dateOfBirthE, setDateOfBirthE] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [Reason, setReason] = useState('')

    let url = window.location.pathname.split("/")
    const pathName = url[url.length - 1]

    const getEmployeeData = (value) => {
        let temp = {
            Type: "GetEmployee",
            Prefix: '',
            ContextKey:'',
            ContextKey2: ""
        }
        setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setEmployeeData([])
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setEmployeeData(data)
                }
            }
        });
    }

    const getCompanyData = (value) => {
        let temp = {
            Type: "GetCompany",
            Prefix: '',
            ContextKey: '',
            ContextKey2: ""
        }
        setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setCompanyData([])
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setCompanyData(data)
                }
            }
        });
    }

    const HandleChange = (prop, value) => {
        if (prop === 'ToDate') {
            setToDate(value)
        } else if (prop === 'FromDate') {
            setFromDate(value)
        }
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    //validation handler
    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            { field: "FromDate", msg: 'Please Select From Date.' },
            { field: "ToDate", msg: 'Please Enter ToDate.' },
        ]

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0) {
                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });


        return isValid;
    }

    //Submit Handler
    const handleSubmit = (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }

        // setLoading(true)

        let temp = {
            PageIndex: PageIndex.toString(),
            SearchText: "",
            StartValue: "1",
            SearchFieldValue: "",
            Type: "s"
        }
        post(`${API_SERVER}api/Employee/SearchAttendanceVerification`, { ...TokenData, ...temp, ...sortConfig, ...filterData, ...recipe}, (res) => {

            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    toast.error(res.Message)
                    setLoading(false)
                    setResult({ ...res })
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    //toast.success(res.Message)
                    setResult({ ...res })
                    setShowTable(true)
                    //getFormData()
                    // handleClear()
                    //console.log(recipe, 'else')
                }
            }
        });

    }

    const handleChange1 = (event, value) => {
        // getFormData(value);
        handleSubmit(value);
    };
    //Handle Edit
    const handleCheckData = (Id, e, item, index) => {
        if (e) {
            setAttendanceDetails((preValue) => [
                ...preValue,
                `${Id}|${item.ActualInTime}|${item.ActualOutTime}`
            ]);
        } else {
            const updatedIds = AttendanceDetails.filter(
                ele => ele.split('|')[0] !== Id
            );
            setAttendanceDetails(updatedIds);
        }
    };

    const handleCheckAll = (checked, data) => {
        if (checked) {
            const allIds = data.map(item =>
                `${item.CheckBox}|${item.ActualInTime}|${item.ActualOutTime}`
            );
            setAttendanceDetails(allIds);
        } else {
            setAttendanceDetails([]);
        }
    };

    // handle verify data
    const handleVerify = () => {

        post(`${API_SERVER}api/Employee/VerifyAttendance`, { ...TokenData, Type: 'Verify', AttendanceDetails: (AttendanceDetails.length > 0 ? `${AttendanceDetails.join(",")}` : '') }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.status === "EXPIRED") {
                    toast.error(res.message)
                    sessionExpired()
                } else if (res.status === "UNAUTHORIZED") {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    toast.success(res.message)
                    setLoading(false)
                    setShowTable(false)
                }
            }
        });
    }

    // handle Reject 
    const handleReject = () => {
        post(`${API_SERVER}api/Employee/VerifyAttendance`, { ...TokenData, Type: 'Reject', AttendanceDetails: (AttendanceDetails.length > 0 ? `${AttendanceDetails.join(",")}` : '') }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.status === "EXPIRED") {
                    toast.error(res.message)
                    sessionExpired()
                } else if (res.status === "UNAUTHORIZED") {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    toast.success(res.message)
                    setLoading(false)
                    setShowTable(false)
                }
            }
        });
    }

    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({
            ...recipe,
            Employee: '',
            FromDate: '',
            ToDate: ''
        }))
        setErrors({})
        setFilterData(filterData => ({ ...filterData, SearchText: '' }))
        setIsUpdate(!isUpdate)
        setShowTable(false)
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    //Start Export functionality
    let ExportRequest = {
        ...filterData,
        ...TokenData,
        ...sortConfig,
        Type: 'E',
        PageIndex: '1'

    }
    //End Export functionality

    useEffect(() => {
        inputrefs.current['txtEmployee'].focus()
        document.title = 'Viva HRMS: Attendance Verification'
        getEmployeeData();
        getCompanyData();
        //    getFormData()
    }, [sortConfig, isUpdate])


    let EmpData = []
    for (let i = 0; i < EmployeeData.length; i++) {
        let mydata = EmployeeData[i]?.values
        EmpData.push(mydata)
    };

    let CmpData = []
    for (let i = 0; i < CompanyData.length; i++) {
        let mydata = CompanyData[i]?.values
        CmpData.push(mydata)
    };

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> Verify Attendance</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>

                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtEmployee'].focus() };
                            }}
                            label='Company'
                            placeholder="Company"
                            maxLength='100'
                            options={CmpData}
                            id='txtCompany'
                            required={true}
                            error={errors.Company}
                            inputValue={recipe.Company}
                            disabled
                            onInputChange={(event, newInputValue) => {
                                HandleChange('Company', newInputValue)
                                //setStatePre(newInputValue)
                            }}
                        />
                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtFromDate'].focus() };
                            }}
                            label='Employee'
                            placeholder="Employee"
                            maxLength='100'
                            options={EmpData}
                            id='txtEmployee'
                            required={true}
                            error={errors.Employee}
                            inputValue={recipe.Employee}
                            onInputChange={(event, newInputValue) => {
                                HandleChange('Employee', newInputValue)
                                //setStatePre(newInputValue)
                            }}
                        />
                        <DateBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtToDate'].focus() };
                            }}
                            label='From Date'
                            id='txtFromDate'
                            selected={fromDate}
                            placeholder="From Date"
                            value={recipe.FromDate}
                            onChange={(e) => HandleChange('FromDate', e)}
                        // required
                        //  error={errors.FromDate}
                        />
                        <DateBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { handleSubmit() };
                            }}
                            label='To Date'
                            id='txtToDate'
                            selected={toDate}
                            placeholder="To Date"
                            value={recipe.ToDate}
                            onChange={(e) => HandleChange('ToDate', e)}
                        //   required
                        //  error={errors.ToDate}
                        />

                        <FormButton
                            SaveText='Search'
                            Export={false}
                            Next={true}
                            saveButtonIcon='fa-search'
                            nextButtonText='Verify'
                            nextButtonIcon='fa-check'
                            nextButtonColor='btn-success'
                            handleNext={handleVerify}
                            Reject1={true}
                            handleReject1={handleReject}
                            handleSubmit={handleSubmit}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>

            {/* Table Component start */}
            {showTable &&

                <OperationalTable
                    Filter={false}
                    Token={TokenData}
                    PageName='VerifyAttendance'
                    pathName='VerifyAttendance'
                    handleCheckData={handleCheckData}
                    handleCheckAll={handleCheckAll}
                    tableData={result}
                    loading={loading}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    selectedData={AttendanceDetails}
                />
            }
            {/* Table Component End*/}


            {/* Loder start*/}
            {loading && < BlurLoader />}
            {/* Loder End*/}

        </>
    )
}

export default AttandanceVerification;